import { Delivery, StackedDelivery } from './Delivery';
import { Pickup } from './Pickup';
import { Dropoff } from './Dropoff';

export enum JOB_STATUS {
    AWAITING_STACK_COMPLETION = 'AWAITING_STACK_COMPLETION',
    AWAITING_STACKED_JOB_CREATION = 'AWAITING_STACKED_JOB_CREATION',
    STACKED_JOB_CREATED = 'STACKED_JOB_CREATED',
    AWAITING_JOB_CREATION = 'AWAITING_JOB_CREATION',
    JOB_CREATED = 'JOB_CREATED',
    JOB_CREATION_FAILED = 'JOB_CREATION_FAILED',
    CANCELED = 'CANCELED',
}

export interface Job {
    id: number;
    stack_id: number | null;
    readonly created_at: Date | string;
    status: string;
    package_type: string;
    transport_type: string | null;
    assignment_code: string | null;
    pickup_at: Date | string;
    comment: string;
    deliveries: Delivery[];
    api_job_id?: number;
    dashboard_url?: string;
    client_id?: number;
    client_name?: string;
}

export interface JobSummary {
    key?: string;
    id: number;
    status: string;
    pickUpAt: Date | string;
    clientReference: string;
    pickUpAddress: string;
    dropOffAddress: string;
    stackId: number | null;
    client?: {
        id: number;
        name: string;
    };
    createdAt: Date | string;
}

export interface JobDetailedDelivery {
    deliveryId: number;
    key: string;
    clientReference: string;
    packageDescription: string;
    packageType: string;
    pickup: Pickup;
    dropoff: Dropoff;
}
export interface JobDetailed {
    key?: string;
    id: number;
    status: string;
    createdAt: Date | string;
    packageType: string;
    transportType: string | null;
    assignmentCode: string | null;
    pickupAt: Date | string;
    comment: string;
    deliveries: JobDetailedDelivery[];
    apiJobId: number | null;
    dashboardURL?: string;
    stackId: number | null;
    client_id?: number;
    client_name?: string;
}
export interface StackedJob {
    key?: number;
    id: number;
    status: string;
    apiJobId: number | null;
    pickupAt: Date | string;
    dropoffAt: Date | string;
    assignmentCode: string | null;
    transportType: string | null;
    fleets?: any;
    createdAt: Date | string;
    updatedAt: Date | string;
    clientId: number;
    stackId: number;
    deliveries: StackedDelivery[];
}
